import { DocumentData } from "firebase/firestore";
import { GridElement } from "../../../types/gridElement";
import { beforeWrapper, borderSettings } from "../../../utils";
import { ShowTableData } from "../../ShowTableData";

export const NetSales = ({
  headers,
  rows,
  state,
  descriptions,
  dataUrl,
  url,
  unit,
}: {
  headers: DocumentData[];
  rows: DocumentData;
  state: DocumentData;
  descriptions: DocumentData;
  dataUrl: string;
  url: string;
  unit: number;
}) => {
  const grid: GridElement[][] = [];

  // className
  const classCol1 = `${beforeWrapper} p-4px left-0 text-14px font-bold bg-white before:border-x before:border-r-c3333334d before:border-b `;

  const classCol2 = `${borderSettings} p-4px before:border-l before:border-l-c3333334d
        before:border-b text-14px  text-right`;

  const classCol3 = `${borderSettings} p-4px before:border-x before:border-l-c3333334d
        before:border-b text-14px h-50px description`;

  const gridRow: GridElement[] = [
    {
      value: "①売上高",
      readOnly: true,
      className: `${classCol1}`,
    },
  ];

  headers?.map((header: DocumentData, tdIndex: number) => {
    if (tdIndex === 0) return;

    gridRow.push({
      value: ShowTableData(state.plans_total[tdIndex - 1] / unit),
      expr: state.plans_total[tdIndex - 1] / unit,
      readOnly: tdIndex < 1 ? false : true,
      className: `${classCol2}`,
      row: rows[0],
      url: dataUrl,
      key: header.period,
    });
  });

  gridRow.push({
    value: descriptions[`${url}_net_sales`],
    readOnly: false,
    className: `${classCol3}`,
    field: `${url}_net_sales`,
    key: "descriptions_calc",
    row: descriptions,
  });
  grid.push(gridRow);

  return grid;
};
